export enum SETTINGS_TAB {
  USERS = 'users',
  USER_MANAGEMENT = 'user-management',
  ELIGIBILITY_AND_PROVISIONING = 'eligibility-and-provisioning',
  MSP_MANAGEMENT = 'msp-management',
  COMPLIANCE_AND_RISK_ALERTS = 'program-alerts',
  BUSINESS_SITES = 'locations',
  OLD_PERMISSIONS = 'policies',
  SECURITY_PERMISSIONS = 'security-permissions',
  CLASSIFICATIONS = 'classifications',
  COMPANIES = 'companies',
  CUSTOM_FIELDS = 'custom-fields',
  CUSTOM_FIELDS_AND_OBJECTS = 'custom-fields-and-objects',
  BUSINESS_EVENTS = 'business-events',
  ENGAGEMENTS = 'engagements',
  WORKERS = 'workers',
  ENTERPRISE = 'enterprise',
  PROCESSES = 'processes',
  SPEND_SETTINGS = 'spend',
  SPEND_GENERAL = 'general',
  TIMESHEET = 'timesheet',
  FINANCIAL_FIELDS = 'financial-fields',
  INVOICE_BLUEPRINTS = 'blueprints',
  INVOICES = 'invoices',
  INVOICE_GENERAL = 'general',
  BUDGET = 'budget',
  SMART_FORMS = 'smart-forms',
  INTEGRATIONS = 'integrations',
  API_KEYS = 'api-keys',
  SSO_INTEGRATIONS = 'sso-integrations',
  CONNECTORS = 'connectors',
  MONITORING = 'monitoring',
  USER_INTERFACE_SETTINGS = 'user-interface-settings',
  FIELD_METADATA = 'field-metadata',
  TENANTS = 'tenants',
  ROLES = 'roles',
  RECIPES = 'recipes',
  SOURCING = 'sourcing',
  ANALYTICS_DASHBOARDS = 'analytics-dashboards',
  SFTP = 'sftp',
  ABOUT_US = 'about',
  DEV_TOOLS = 'dev-tools',
  CONTRACTS = 'contracts'
}
